// extracted by mini-css-extract-plugin
export default {"footer_div":"Footer_footer_div__lxmvQ","higher_div":"Footer_higher_div__Fgw5p","lower_div":"Footer_lower_div__1cllS","ichb_logo":"Footer_ichb_logo__FxAcT"};